import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { Movement } from '@base/src/app/models/renditions/renditionMovement.model';
import { TableHeader } from '@base/src/app/models/tableheader.model';

export interface MovementSplited {
  type: string;
  descr: string;
  cashBox: string;
  billingType: string;
  currency: string;
  subtotal: number;
  [key: string]: string | number;
}
export type ListMovementKey = keyof MovementSplited;

@Component({
  selector: 'app-rendition-movement-split',
  templateUrl: './rendition-movement-split.component.html',
  styleUrls: ['./rendition-movement-split.component.scss'],
})
export class RenditionMovementSplitComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: undefined | { mov: Movement; index: number; type: number };

  tableHeader: TableHeader[] = [
    {
      id: 'type',
      text: 'Tipo',
      percentageWidth: 12.2,
      isOrderByVisible: false,
    },
    {
      id: 'description',
      text: 'Descripción',
      percentageWidth: 31.7,
      isOrderByVisible: false,
    },
    {
      id: 'cash-boxes',
      text: 'Caja',
      percentageWidth: 19.5,
      isOrderByVisible: false,
    },
    {
      id: 'billing-type',
      text: 'Comp.',
      percentageWidth: 12.5,
      isOrderByVisible: false,
    },
    {
      id: 'currency',
      text: 'Moneda',
      percentageWidth: 12.2,
      isOrderByVisible: false,
    },
    {
      id: 'subtotal',
      text: 'Subtotal',
      percentageWidth: 12.2,
      isOrderByVisible: false,
    },
  ];

  listMovement: MovementSplited[] = [];
  listMovementKey: ListMovementKey[] = [];

  ngOnInit(): void {
    if (this.value) {
      const itemSubtotal: MovementSplited = {
        type: this.value.type == 0 ? 'Ingreso' : 'Egreso',
        descr: this.value.mov.description,
        cashBox: this.value.mov.cashBox,
        billingType: this.value.mov.billingType,
        currency: this.value.mov.currency,
        subtotal: this.value.mov.subtotal,
      };

      const itemIVA: MovementSplited = {
        ...itemSubtotal,
        subtotal: this.value.mov.iva,
      };

      this.listMovement.push(itemSubtotal, itemIVA);

      this.listMovementKey = Object.keys(this.listMovement[0]);

      const dialogEvent = {
        isButtonActionDisabled: false,
        value: { index: this.value?.index, type: this.value?.type },
      };
      //Emito y actualizo
      this.dialogChange.emit(dialogEvent);
    }
  }
}
